import React from 'react';
import IconText from '../../../Voting/containers/votings-list/components/icon-text';
import Author from '../Author/Author';
import { formatDate } from '../../utils';

export const getActions = (item) => {
  const actions = [
    <IconText
      type=""
      text={
        <span style={{ color: '#0995ed', fontWeight: 600 }}>{item.id}</span>
      }
      key="list-vertical-star-o"
    />,
    <IconText
      type="calendar-o"
      text={formatDate(item.createTime)}
      key="list-vertical-like-o"
    />,
    <IconText
      type="user-o"
      key="list-vertical-user-o"
      tip={item.worker ? <Author author={item.worker} /> : ''}
    />,
  ];

  if (item.hasAttachment)
    actions.push(
      <IconText type="paper-clip-o" key="list-vertical-hasAttachment" />
    );

  return actions;
};
